export default __webpack_public_path__ + "static/comp-adaa375a150c3592e961d4356f3053fe.png";